var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2592 29.6852C23.517 28.9295 24.667 32.3641 22.408 33.1199C20.3507 33.8105 18.1648 34.0988 15.9983 33.9712C6.62962 33.4174 -0.522282 25.3675 0.0302179 15.9992C0.584044 6.63049 8.63392 -0.522772 18.0023 0.0310881C27.371 0.584914 34.5229 8.63479 33.9704 18.0031C33.9266 18.7602 33.8269 19.5557 33.6795 20.2995C33.2226 22.6423 29.6607 21.9477 30.1173 19.6049C30.2382 18.9913 30.3152 18.4149 30.3511 17.7906C30.7867 10.4262 25.1542 4.08457 17.7898 3.65005C10.4254 3.21444 4.08371 8.84695 3.64919 16.2113C3.21358 23.5757 8.84609 29.9174 16.2105 30.3519C17.9291 30.4529 19.6265 30.2337 21.2588 29.6852H21.2592Z",
    fill: "#8997BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArc);
export default __webpack_public_path__ + "static/media/arc.35131d2d796251be8c0cf95e226c3a26.svg";
export { ForwardRef as ReactComponent };